module.exports = __webpack_public_path__ + "img/smartmail-main@2x.3cd0fe14.png";